//import ViewTodoWordResultOnePopup from "@/pages/comp/plan/todo/popup/view_todo_word_result_one";
import ViewTodoWordResultOneArea from "@/pages/comp/plan/todo/common/view_todo_word_result_one";

function ViewTodoWordResultOnePopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    todo_pri_val_arr: [],
    ...props
  };
  return (
    <div>
      <ViewTodoWordResultOneArea
        {...myProps}
      ></ViewTodoWordResultOneArea>
    </div>
  );
}

export default ViewTodoWordResultOnePopup;
